/**
 * La maglia in testa alle righe dei giocatori, uguale in tutte le liste: la
 * fascia con la sigla del ruolo e sotto il numero. La fascia è grigia; la
 * rosa la colora con lo stato di salute del giocatore. Nelle righe prende
 * tutta l'altezza, con il numero al centro dello spazio sotto la fascia.
 * Compatta, per le tabelle fitte, è più stretta e più bassa.
 */

import type { RuoloGiocatore } from '@calcio/shared';
import { cn } from '@/lib/utils';
import { SIGLA_RUOLO } from '../giocatori/elenchi.js';

export function Maglia({
  numero,
  ruolo,
  fascia = 'bg-muted text-muted-foreground',
  compatta = false,
  className,
}: {
  numero: number | null;
  /** Null per chi non è più nella rosa alla data: la fascia resta vuota. */
  ruolo: RuoloGiocatore | null;
  /** Fondo e testo della fascia. */
  fascia?: string;
  compatta?: boolean;
  className?: string;
}) {
  return (
    <span
      className={cn(
        'flex w-14 shrink-0 flex-col self-stretch overflow-hidden rounded-md border border-border bg-background text-center',
        compatta && 'w-10 self-auto',
        className,
      )}
    >
      <span
        className={cn(
          'min-h-5 py-0.5 text-[11px] font-semibold uppercase',
          compatta && 'min-h-0 py-0 text-[10px] leading-4',
          fascia,
        )}
      >
        {ruolo ? SIGLA_RUOLO[ruolo] : ''}
      </span>
      <span
        className={cn(
          'flex flex-1 items-center justify-center py-1 text-2xl leading-7 font-bold tabular-nums',
          compatta && 'py-0 text-base leading-6',
        )}
      >
        {numero ?? '—'}
      </span>
    </span>
  );
}
